// extracted by mini-css-extract-plugin
export var createdDate = "_nr-1";
export var divider = "_nr-2";
export var headerDivider = "_nr-3";
export var messagesCard = "_nr-0";
export var messagesContainer = "_nr-7";
export var messagesContainerWrapper = "_nr-4";
export var pointerCapturingButtonBoxes = "_nr-a";
export var showLeftPanelButton = "_nr-9";
export var showMoreButton = "_nr-c";
export var showMoreButtonContainer = "_nr-b";
export var summaryTitle = "_nr-6";
export var systemMessageCardWrapper = "_nr-d";
export var topButtons = "_nr-8";
export var withPadding = "_nr-5";